/** @flow */
export default from './Collection'
export Collection from './Collection'



// WEBPACK FOOTER //
// ./source/Collection/index.js